<template>
  <div class="bg-primary mb-3 py-4">
    <div class="d-flex align-center mxw-1000 mx-auto px-6">
      <img
        v-if="image"
        :src="image"
        alt=""
        class="me-4"
        style="height: 80px"
      />

      <div>
        <h1
          class="fs-24 fw-600 c-white mb-0"
          data-cy="page-hero-title"
        >
          {{ $bct(title) }}
        </h1>

        <MarkdownContent
          :content="subtitle"
          class="fs-18 fw-500 c-white"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import MarkdownContent from '@/shared/components/MarkdownContent.vue';

const $bct = inject('translator');

defineProps({
  image: { type: String, default: null },
  subtitle: { type: String, default: null },
  title: { type: String, default: null },
});
</script>
